<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">
      <el-form-item :label="`${$t('lang.序号')}：`" prop="number">
        <el-select v-model="formData.number" :placeholder="$t('lang.请选择')">
          <el-option v-for="i in 30" :key="i" :label="i" :value="i"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="`${$t('lang.图片')}：`" prop="photo">
        <el-upload
            ref="uploadfiles"
            :action="api.upload"
            :limit="1"
            :on-change="handleUploadFile"
            :on-remove="handleRemoveFile"
            :file-list="photoImg"
            :data="{category: 'ADVERTISING'}"
            list-type="picture-card">
          <i class="el-icon-plus"></i>
        </el-upload>
        <span style="color: #ef0b5a">720*1280px</span>
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>

export default {
  name: "LockScreenAdsEdit",
  components: {},
  data() {

    return {
      api: {
        update: this.$api.lockScreenAds.update,
        detail: this.$api.lockScreenAds.detail,
        upload: this.$api.file.upload,
        download: this.$api.file.download
      },
      formErrorMsg: {name: ''},
      formData: {
        subBrandProductCode: this.$route.query.code,
        number: '',
        photo: '',
        code: ''
      },
      photoImg: []
    }
  },
  computed: {
    rules() {
      let checkPhoto = (rule, value, callback) => {
        if(!this.formData['photo']) {
          return callback(new Error(this.$t('lang.图片不能为空')))
        }
        return callback();
      };
      return {
        number: [
          {required: true, message: this.$t('lang.序号不能为空'), trigger: 'blur'}
        ],
        photo: [
          {required: true, validator: checkPhoto, trigger: 'blur'}
        ],

      }
    }
  },
  methods: {
    handleUploadFile(file) {
      const vm = this;
      if(file.percentage == 100) {
        let {response: res} = file;
        if(res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        vm.formData['photo'] = res.data.fileCode;
        this.$refs.form.clearValidate('photo');
      }
    },
    handleRemoveFile() {
      this.formData['photo'] = '';
    },
    handleSubmit(form) {

      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let {code, number, photo} = vm.formData;
          let data = {code, number, photo};
          data.number = data.number + ''
          vm.$http.post(vm.api.update, this.$qs.stringify(data)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              vm.$message({
                type: "error",
                message: resp.data.desc
              });
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs.uploadfiles.clearFiles();
      this.$refs[form].resetFields();
    }
  },

  created() {

    let vm = this;
    this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
      if(resp.data.status != 200) {
        vm.$message.error(resp.data.desc);
        return;
      }

      let data = resp.data.data['lockScreenAds'];
      let img = vm.api.download + '?fileCode=' + data['photo'];
      vm.photoImg.push({url: img});
      vm.formData = data;

    });

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}
</style>
